import { FormControl, FormGroup } from '@material-ui/core';

import { CheckboxOption, SideBarDialog } from 'shared/components';

import { useTurnOffCustomizationList } from './hooks';

import makeClasses from './TurnOffCustomizationList.style';

import type {
  FullMenuCatalog,
  IMenuCustomization,
} from 'features/menu-page/domain';
import type { CustomizationId } from 'shared/domain';

export function TurnOffCustomizationList(props: Props) {
  const { catalog, customizationList, cancelCTA, turnOffCTA } = props;
  const hasCustomList = customizationList.length > 0;
  if (!hasCustomList) return null;

  const {
    lang,
    customs,
    checked,
    isCheckAll,
    disableCTA,
    handleOnChange,
    handleCallToAction,
  } = useTurnOffCustomizationList({ catalog, customizationList, turnOffCTA });

  const _classes = makeClasses();

  return (
    <SideBarDialog
      size='small'
      open={hasCustomList}
      onClose={cancelCTA}
      headerTitle={lang.title}
      posNav={
        <div className={_classes.info}>
          <p aria-label='info-name'>{customizationList[0].description}</p>
        </div>
      }
      actions={{
        primaryBtn: {
          disabled: disableCTA,
          children: lang.action.primaryBtn,
          onClick: handleCallToAction,
        },
        secondaryBtn: {
          children: lang.action.secondaryBtn,
          onClick: cancelCTA,
        },
      }}
    >
      <p className={_classes.paragraph}>{lang.preForm.paragraph}</p>

      <FormControl fullWidth component='fieldset'>
        <FormGroup
          onChange={handleOnChange}
          classes={{ root: _classes.formControl }}
        >
          <CheckboxOption
            name='all'
            checked={isCheckAll}
            title={lang.form.all.title}
            classes={{ label: { root: _classes.optionAll } }}
          />
          {customs.map(custom => (
            <CheckboxOption
              key={custom.id}
              data-custom-id={custom.id}
              name={custom.id.toString()}
              checked={checked.has(custom.id)}
              title={custom.extra.title}
              description={`${lang.form.option.description}${custom.extra.description}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    </SideBarDialog>
  );
}

interface Props {
  catalog: FullMenuCatalog;
  customizationList: IMenuCustomization[];
  cancelCTA: () => void;
  turnOffCTA: (ids: CustomizationId[]) => void;
}
